import { render, staticRenderFns } from "./package-price.vue?vue&type=template&id=472322e8&scoped=true"
import script from "./package-price.vue?vue&type=script&lang=js"
export * from "./package-price.vue?vue&type=script&lang=js"
import style0 from "./package-price.vue?vue&type=style&index=0&id=472322e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472322e8",
  null
  
)

export default component.exports